import { deleteData, postData } from '../backend';
import { useModal } from '../contexts';
import { BLOCK_ICON_MAP } from '../utils';
import Modal from './Modal';
import useUser from '../hooks/useUser';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface Props {
  appObjectsEnabled?: boolean;
  onDisconnect?: () => void;
  onReauthorise?: () => void;
}

function SettingsModalHubspot(props: Props) {
  const { refreshUser } = useUser();
  const { closeModal } = useModal();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  async function handleDeletHubspotCredentials() {
    setIsLoading(true);

    await deleteData("/hubspot/credentials/")
      .catch(console.error);

    props.onDisconnect?.();
    refreshUser();
    closeModal();

    setIsLoading(false);
  }

  async function handleEnableAppObjects() {
    setIsLoading(true);

    try {
      const { url } = await postData("/hubspot/install-app-objects/");
      window.open(url, "_blank");

      props.onReauthorise?.();
      closeModal();
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  }

  return (
    <Modal
      primaryButtonProps={{ text: t("Disconnect"), className: "btn-red", onClick: handleDeletHubspotCredentials, disabled: isLoading }}
      className='relative justify-start'
      size='sm'
    >
      <div className="flex items-center gap-2">
        <img className="h-10 w-10" src={BLOCK_ICON_MAP["HUBSPOT"]} alt="Google Sheets Icon" />
        <div className="flex flex-col">
          <div className="font-gilroy font-semibold">
            HubSpot
          </div>
          <div className="text-gray-600 text-sm">{t("Portant currently has access to your data in HubSpot")}</div>
        </div>
      </div>
      {/* App object scopes can only be added by re-authorising, they cannot be removed without disconnecting */}
      <div className="flex items-center gap-4 mt-6">
        <div className="flex flex-col">
          <span className="font-semibold text-sm">{t("Enable document app objects")}</span>
          <span className="text-gray-400 text-xs">{t("Store generated documents as Portant Document objects in HubSpot. This requires additional HubSpot permissions.")}</span>
        </div>
        {props.appObjectsEnabled
          ? <span className="text-green text-sm font-semibold ml-auto flex-shrink-0">{t("Connected")}</span>
          : <button className="btn btn-white text-sm py-1 px-2 ml-auto flex-shrink-0" disabled={isLoading} onClick={handleEnableAppObjects}>{t("Connect")}</button>
        }
      </div>
    </Modal>
  );
}

export default SettingsModalHubspot;
